import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { DocumentsLibrary } from '../../Models/Domains/Documents/DocumentsLibrary';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class ProspectDocumentsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(actorId: number, fromDate: IJsonDate, toDate: IJsonDate, minRow: number, maxRow: number): Promise<DocumentsLibrary, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/ProspectDocuments/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { actorId: actorId, fromDate: fromDate, toDate: toDate, minRow: minRow, maxRow: maxRow }

    return AjaxWrapper.get<DocumentsLibrary, any>(url, data);
  }
}

